module.exports = __webpack_public_path__ + "static/media/projects.f6bca7df.png";